import React from 'react';
import ReactApexChart from 'react-apexcharts';

interface HorizontalBarChartProps {
    data: Array<{
        category: string;
        value: number;
    }>;
    height?: number;
}

const HorizontalBarChart: React.FC<HorizontalBarChartProps> = ({
    data,
    height = 350
}) => {
    const options = {
        chart: {
            type: 'bar' as const,
            toolbar: {
                show: false
            }
        },
        plotOptions: {
            bar: {
                horizontal: true,
                barHeight: '70%',
                distributed: true,
                dataLabels: {
                    position: 'right',
                    offsetX: 5
                }
            }
        },
        colors: ['#1976d2'],
        dataLabels: {
            enabled: true,
            textAnchor: 'start' as const,
            style: {
                fontFamily: ['Roboto Slab', 'Arial', 'sans-serif'].join(','),
                marginLeft: '5px',
                colors: ['#333'],
                fontSize: '14px',
                fontWeight: 600
            },
            formatter: function (val: number) {
                return val.toString();
            },
            background: {
                enabled: false
            }
        },
        xaxis: {
            categories: data.map(item => item.category),
            labels: {
                style: {
                    fontSize: '14px'
                }
            }
        },
        yaxis: {
            labels: {
                show: true,
                style: {
                    fontFamily: ['Roboto Slab', 'Arial', 'sans-serif'].join(','),
                    marginLeft: '5px',
                    fontSize: '14px',
                    colors: '#333'
                }
            }
        },
        grid: {
            xaxis: {
                lines: {
                    show: false
                }
            },
            yaxis: {
                lines: {
                    show: false
                }
            }
        },
        tooltip: {
            enabled: true,
            y: {
                formatter: function (val: number) {
                    return val.toString();
                }
            },
            custom: function ({ series, seriesIndex, dataPointIndex, w }: any) {
                return `<div class="arrow_box">
                  <span>
                    ${w.globals.labels[dataPointIndex]}: ${series[seriesIndex][dataPointIndex]}
                  </span>
                </div>`;
            }
        }
    };

    const series = [{
        data: data.map(item => item.value)
    }];

    return (
        <ReactApexChart
            options={options}
            series={series}
            type="bar"
            height={height}
        />
    );
};

export default HorizontalBarChart;